import { render, staticRenderFns } from "./AggregateLearningLeaderboardSort.vue?vue&type=template&id=73a0ba0a"
import script from "./AggregateLearningLeaderboardSort.vue?vue&type=script&lang=js"
export * from "./AggregateLearningLeaderboardSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports